import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'redux/store';
import { updateUser, setUserSetting } from 'redux/slices/auth';
import { selectUseLocalTimezone } from 'redux/selectors/userSettings';

// Self-contained switch for the "use local timezone" preference. Owns the
// read (selector) and write (optimistic setUserSetting + persisted
// updateUser), so it can be dropped anywhere without prop threading. Every
// FormatDateTime subscribes to the same selector, so toggling reflows all
// timestamps with no reload.
const ToggleUseLocalTimezone = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const localTimezone = useAppSelector(selectUseLocalTimezone);
  const user_settings = useAppSelector((state) => state.auth.userData?.user_settings ?? {});

  const toggle = () => {
    const newValue = !localTimezone;
    dispatch(setUserSetting({ key: 'useLocalTimezone', value: newValue }));
    dispatch(
      updateUser({
        user_settings: { ...user_settings, useLocalTimezone: newValue },
      })
    );
  };

  return <Form.Check type="switch" id="timezone-switch" checked={localTimezone} onChange={toggle} label={t('tableView.useLocalTimezone')} />;
};

export default ToggleUseLocalTimezone;
